import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Challenge } from 'src/types/shared/Challenge';

export const editChallengeLeadRequest = createAction('editChallengeLeadRequest');
export const editChallengeLeadSuccess = createAction<Challenge>('editChallengeLeadSuccess');
export const editChallengeLeadFailure = createAction('editChallengeLeadFailure');

export const editChallengeLead = (postbody: EditChallengeLeadRequest) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(editChallengeLeadRequest());
    try {
        const { data } = await api.patch<EditChallengeLeadRequest, Challenge>(
            'admin/challenges/update-challengelead',
            postbody,
        );

        dispatch(editChallengeLeadSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, editChallengeLeadFailure, e);
    }
};

export interface EditChallengeLeadRequest {
    leadID: number | null;
    challengeID: number;
}
